// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import SentryErrorBoundaryFallback from './data'

export default function SentryErrorBoundaryFallbackFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/SentryErrorBoundary/SentryErrorBoundaryFallback">
      <SentryErrorBoundaryFallback {...props}>
        {children}
      </SentryErrorBoundaryFallback>
    </Flow>
  )
}
